<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { notify } from '@/helpers/notify' 

export default {
    page: {
    title: "Sms Şablonları",
    meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
    },
    data(){
        return {
            load:true,
            title: "SMS ŞABLONLARI",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "SMS ŞABLONLARI",
                    active: true,
                },
            ],
            form:{},
            projectData: []
        }
    },
    mounted(){
      this.getList()
    },
    methods:{
      getList(){
        this.$http.post(`/smsSchema`)
          .then(resp => {
              this.projectData = resp.data
          })
          .catch(error => error)
          .finally(() => this.dataLoading=false)
      },
      edit(params){
        this.form = { ...params }
      },
      save(){
        this.$http.post(`/smsSchema/store`, { ...this.form })
        .then(() => {
           this.form = {}
           this.getList()
        })
        .catch(error => error)
        .finally(() => this.dataLoading=false)
      },
      update(){
          this.$http.put(`/smsSchema/${this.form.id}`, { ...this.form })
          .then(() => {
              this.form = {}
              this.getList()
          })
          .catch(error => error)
          .finally(() => this.dataLoading=false)
      },
      remove({id}){
        this.$http.delete('/smsSchema/' + id)
          .then(resp => {
            if(resp.data.code !==  100)  return notify.error(resp.data.message)
            this.getList()
            return notify.success(resp.data.message)
          })
          .catch(error => error)
      }
    }
    
}
</script>
<template>
 <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div>
          <div class="table-responsive">
            <table
              class="table project-list-table  table-centered table-borderless align-middle"
            >
              <thead>
                <tr>
                  <th scope="col" style="width:20%">Tanım</th>
                  <th scope="col">İçerik</th>
                  <th scope="col" style="width:5%"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td><input type="text" v-model="form.title" class="form-control"></td>
                    <td><input type="text" v-model="form.content" class="form-control"></td>
                    <td>
                        <button 
                            v-if="form.id"
                            @click="update()" 
                            class="btn btn-warning">
                            Güncelle
                        </button>
                         <button 
                            v-else
                            @click="save()" 
                            class="btn btn-primary">
                            Ekle
                        </button>
                    </td>
                </tr>
                <tr v-if="projectData.length == 0">
                  <td colspan=4 class="text-center">Kayıt Bulunmamaktadır</td>
                </tr>
                <tr v-for="project in projectData" :key="project.id">
                  <td>
                    <h5 class="text-truncate font-size-14">
                     {{ project.title }}
                    </h5>
                  </td>
                  <td>{{ project.content }}</td>
                 <td>
                    <b-dropdown
                      class="card-drop"
                      variant="white"
                      menu-class="dropdown-menu-end"
                      right
                      toggle-class="p-0"
                    >
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                      </template>
                      <b-dropdown-item href="javascript: void(0);"
                        @click="edit(project)"
                        >Güncelle</b-dropdown-item
                      >
                      <b-dropdown-item href="javascript: void(0);"
                        @click="remove(project)"
                        >Sil</b-dropdown-item
                      >
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>